<template>
    <div class="scientific-detail common-detail" >
      <template v-if="data.SystemUpgrading" >
        <SystemUpdating/>
      </template>
      <template v-else>
        <div class="details-center">
            <p v-for="(item,index) in data.researchRespList" :key="index">
                <span>{{item.scientificResearchType || '-'}}</span>
                <span class="number">{{item.scientificResearchCount || '-'}}<i>&nbsp;项</i></span>
            </p>
        </div>
        <hr/>
        <div class="recent-list">
            <p class="name">最近科研项目：</p>
            <div class="common-item" v-for="(item,index) in data.lastScientificInfo" :key="index">
                <p class="title" >{{item.scientificName}}</p>
                <p class="time">{{item.scientificDate}}</p>
            </div>
        </div>
        <GoMore v-if="data.pcUrl" text="详细记录&gt;&gt;" :jumpUrl="data.pcUrl"/>
      </template>
    </div>

</template>

<script>
    import GoMore from "./GoMore"
    import SystemUpdating from "./SystemUpdating"
    export default {
        name: "Scientific",
        data(){
            return {
                scientificData: {
                }
            }
        },
        props: {
            data:  { type: Object, default:()=>{}},
        },
        components: {
            GoMore,
          SystemUpdating
        },
    }
</script>

<style scoped lang="scss">
    @import '@/styles/variables.scss';
    .scientific-detail {
        height: 253px;
        background: #e8eaf3;
      hr {
       width: 90%;
        margin:0 auto 10px;
        border:1px dashed #995a73;

      }
        .details-center {
            text-align: end;
            display: flex;
            justify-content: space-around;
            padding: 30px 20px 10px;

            p {
                font-size: 14px;
                color: #3a3550;
                display: flex;
                flex-direction: column-reverse;
                align-items: center;
                justify-content: center;
                margin-bottom: 10px;
                .number {
                    color: #3a3550;
                    font-size: 26px;
                    i {
                        font-size: 14px;
                        font-style: inherit;
                    }

                }
            }
        }
        .recent-list {
            padding: 0 20px;
            color: #333333;
            line-height: 25px;
            p {
                margin-bottom: 10px;
            }
            .common-item {
                display: flex;
                p {
                    width: 50%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    p:nth-child(2) {
                        padding-left: 10px;
                    }

                }
            }
        }
        .more-recode {
            margin-top: 15px;
            padding-right: 31px;
            text-align: right;
            font-size: 12px;
            color: #3a3550;
        }


    }

</style>